<script>
export default {
    props: {
        quotationDetail :{
            type : Object,
        }
    },

    data() {
        return {
            totalEstimate:'',
        }},
    methods: {
        

        totalEstimateCalculate(datas) { 
            return datas.reduce((acc, data) => acc + (data.voucher.voucher_value * data.trade_up.quantity), 0); 
        },
    },
    mounted() {
        this.totalEstimate = this.totalEstimateCalculate(this.quotationDetail.device);
    },
}

</script>
<template>
        <table class="table table-borderless table-nowrap align-middle mb-0" border="1">
            <thead>
                <tr class="table-active">
                    <th class="text-start"><center>Trade Up</center></th>
                    <th class="text-start"><center>Trade In</center></th>
                    <th class="text-start"><center>Voucher</center></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(device, index) of quotationDetail.device" :key="index">
                    <td>
                        <!-- <span v-for="(trade_up, index) of device.trade_up" :key="index"> -->
                            {{ device.trade_up.brand }} - {{ device.trade_up.model }} {{ device.trade_up.storage }}<br>
                            {{ quotationDetail.currency }} {{ (device.trade_up.tu_value).toLocaleString('en-US') }} X {{ device.trade_up.quantity }} = <b> {{ quotationDetail.currency }} {{ (device.trade_up.priceing).toLocaleString('en-US') }}</b>
                        <!-- </span> -->
                    </td>
                    <td>
                        <span v-for="(tradein, index) of device.trade_in" :key="index">
                            {{ tradein.brand }} - {{ tradein.model }} {{ tradein.storage }} - Grade {{ tradein.name }} <br>
                            {{ quotationDetail.currency }} {{ (tradein.price).toLocaleString('en-US') }} X {{ tradein.total }} = <b> {{ quotationDetail.currency }} {{ (tradein.priceing).toLocaleString('en-US') }}</b>
                        </span>
                    </td>
                    <td>
                        <center>
                            {{ quotationDetail.currency }} {{ (device.voucher.voucher_value).toLocaleString('en-US') }} X {{ device.trade_up.quantity }} <br>
                            <b>{{ quotationDetail.currency }} {{ (device.voucher.voucher_value*device.trade_up.quantity).toLocaleString('en-US') }}</b>
                        </center>
                    </td>
                    <!-- <td>{{ device.trade_up[index].quantity.toLocaleString('en-US') }}</td>
                    <td>{{ quotationDetail.currency }} {{ device.trade_up[index].tu_value.toLocaleString('en-US') }}</td> -->
                    <!-- <td>{{ device.trade_up[index].priceing.toLocaleString('en-US') }}</td> -->
                </tr>

                <tr>
                    <td></td>
                    <td>Total TIV: <b>{{ quotationDetail.currency }} {{ (quotationDetail.totalAmount).toLocaleString('en-US') }}</b></td>
                    <td>Total Voucher: <b>{{ quotationDetail.currency }} {{ totalEstimate.toLocaleString('en-US') }}</b></td>
                </tr>
                 <tr>
                    <td></td>
                    <td colspan='2' style="text-align:right"><div class='pull-right'>Total TIV+Total voucher: <b>{{ quotationDetail.currency }} {{ (quotationDetail.totalAmount+totalEstimate).toLocaleString('en-US') }}</b></div></td>
                </tr>
            </tbody>
        </table>
            
</template>